{
  "math_hint": "При создании формул используется",
  "math_hint_katex": "синтаксис Katex"
}
